import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import * as data from '../data/mmm-dummy.json';
import * as slotLeftData from '../data/mmm-dummy_LeftAligned.json';
import * as slotRightData from '../data/mmm-dummy_RightAligned.json';
import * as slotTwoColumnData from '../data/mmm-dummy_TwoColumn.json';
import * as slotThreeColumnData from '../data/mmm-dummy_Unequal_3column.json';
 
@Injectable()
export class MarketingMessagesManagerService {
 
  constructor(
    private http: HttpClient    
  ) { }
  mockJson: any[] = (data as any).default;
  mockSlotLeftJson: any[] = (slotLeftData as any).default;
  mockSlotRightJson: any[] = (slotRightData as any).default;
  mockTwoColumnJson: any[] = (slotTwoColumnData as any).default;
  mockThreeColumnJson: any[] = (slotThreeColumnData as any).default;
 
  getCookie(cookieName: string): any {     
    var cookieString = document.cookie ;
    if (cookieString.length == 0) {
        var cookieValue = cookieName ? 'Retirement' : cookieString.match ('(^|;)[\s]*' +cookieName +'=([^;]*)' );
        return cookieValue;
    } else {
      return '';
    }
  }

  isLocal() {
    if (window.location.hostname === 'localhost' || window.location.hostname === 'localhost.prudential.com') {
      return true;
    } else {
      return false;
    }
  }
 
  public getContentInfo(appName:string, slotName:string): Observable<any> { 
    var cookieValue = this.getCookie('AccountType');   
  
    if(this.isLocal()){
      return this.getLocalContent(slotName);
      }
      else{
        let url='';
     if(slotName=='dummyTestSlot1'||slotName=='dummyTestSlot2'||slotName=='dummyTestSlot3'||slotName=='dummyTestSlot4'){
       url = '/contents/get_content';
     }else{
     url = '/contents/contentRecommendation';
     }
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
      
    let body = {
      "appName": appName,
      "slotName": slotName
  }
  
    return this.http
      .post(url, body, {headers: headers}).pipe(
        map(response => response)
        , catchError(error => {           
        let message = error.statusText === '' ? 'An error occurred during the request.' : error.statusText;
        console.log(message);
        return throwError(message);
        
        }));
      }  
  }
 
  public getLocalContent(slotName:string) {  
   
    if(slotName == 'dummyTestSlot1'){
      return of(this.mockSlotLeftJson);
    } else if(slotName == 'dummyTestSlot2'){
      return of(this.mockSlotRightJson);
    }
    else if(slotName == 'dummyTestSlot3'){
     return of(this.mockTwoColumnJson);
   }
   else if(slotName == 'dummyTestSlot4'){
     return of(this.mockThreeColumnJson);
   }
  else{
     return of(this.mockJson);
    }
  
  }
}
